import React from 'react';
import PropTypes from 'prop-types';

import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';

import {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_RED,
} from 'client/components/SrButton/SrButton';

const SrUtilityProfitDeleteDocsConfirmationModal = ({ onConfirm, onCancel }) => {
  return (
    <SrSimpleMessageModal
      iconUrl="/images/big-red-question-mark.png"
      headline="Are you sure you want to delete the documents for the tenants?"
      underline
      maxWidth={400}
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      srMultiButtons={[
        {
          buttonText: 'Confirm & Remove',
          onButtonClick: onConfirm,
          buttonTheme: SR_BUTTON_THEME_ADOBE_RED,
        },
        {
          buttonText: 'Cancel',
          onButtonClick: onCancel,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREY,
        },
      ]}
    />
  );
};

SrUtilityProfitDeleteDocsConfirmationModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

SrUtilityProfitDeleteDocsConfirmationModal.displayName =
  'SrUtilityProfitDeleteDocsConfirmationModal';

export default SrUtilityProfitDeleteDocsConfirmationModal;
